import React from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Icon } from 'semantic-ui-react';
import { logout } from 'actions/auth';
import { Language } from 'language/Language';
import { strings } from './strings';
import './_UserMenu.scss';

const UserMenu = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const currentLocationEn = location.pathname.split('/')[2] || location.pathname.split('/')[1] || location.pathname.split('/')[3];
  const currentLocationJa = location.pathname.split('/')[3] || location.pathname.split('/')[2];
  const language = Language();
  return (
    <div className='menu-user__container'>
      <Link to={language === 'japan' ? '/ja/私のアカウント' : '/my-account'} className={`menu-user__item ${(currentLocationEn === 'my-account' || currentLocationJa === '私のアカウント') && 'menu-user__select'}`}>
        <Icon name='angle right' />
        <p>{strings[language].dashboard}</p>
      </Link>
      <Link to={`${language === 'japan' ? '/ja/私のアカウント' : '/my-account'}/orders`} className={`menu-user__item ${(currentLocationEn === 'orders' || currentLocationJa === 'orders') && 'menu-user__select'}`}>
        <Icon name='angle right' />
        <p>{strings[language].orders}</p>
      </Link>
      <Link to={`${language === 'japan' ? '/ja/私のアカウント' : '/my-account'}/products`} className={`menu-user__item ${(currentLocationEn === 'products' || currentLocationJa === 'products') && 'menu-user__select'}`}>
        <Icon name='angle right' />
        <p>{strings[language].products}</p>
      </Link>
      <Link to={`${language === 'japan' ? '/ja/私のアカウント' : '/my-account'}/edit-account`} className={`menu-user__item ${(currentLocationEn === 'edit-account' || currentLocationJa === 'edit-account') && 'menu-user__select'}`}>
        <Icon name='angle right' />
        <p>{strings[language].details}</p>
      </Link>
      <div className='menu-user__item' onClick={() => dispatch(logout(history, language === 'japan' ? '/ja/私のアカウント' : '/my-account'))}>
        <Icon name='angle right' />
        <p>{strings[language].logout}</p>
      </div>
    </div>
  );
};

export default UserMenu;
